import React, { useState } from 'react';
import { View, TouchableOpacity, Image, StyleSheet } from 'react-native';
import { AntDesign } from '@expo/vector-icons';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ListAltIcon from '@material-ui/icons/ListAlt';
import DoneIcon from '@material-ui/icons/Done';
import Text from '../../../../../components/text';
import Colors from '../../../../../constants/Colors';
import variables from '../variables.json';
import PropertyCard from '../PropertyCard';
import { CardBox } from '../card';
import { SubHeading } from '../../screens/style';
import { colorsTheme } from './../../helpers/theme';

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  iconContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  iconImage: {
    height: 26,
    width: 26,
  },
  heading: {
    fontSize: 13,
    marginLeft: 10,
    color: variables.purple1,
    fontWeight: '600',
    fontFamily: 'lato',
  },
  description: {
    marginTop: 6,
    fontSize: 12,
    fontWeight: '400',
    color: '#333',
  },
  topRight: {
    marginRight: 10 
  },
  statusButton: {
    borderRadius: 6,
    minWidth: 90,
    height: 26,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    paddingHorizontal: 8,
  },
  statusText: {
    fontSize: 11,
    fontFamily: 'lato',
    fontWeight: 'bold',
    marginLeft: 5,
  },
});

const StatusButton = ({ type }) => {
  let backgroundColor = '',
    borderColor = '',
    text = '',
    icon = null,
    textColor = '#fff';

  switch (type) {
    case 'complete':
      backgroundColor = colorsTheme.green;
      text = 'Completed';
      icon = <DoneIcon style={{ fontSize: 16, color: '#fff' }} />;
      break;
    case 'incomplete':
      backgroundColor = colorsTheme.pink;
      text = 'Not Started';
      break;
    default:
      backgroundColor = colorsTheme.yellow;
      text = 'In Progress';
      break;
  }

  return (
    <View
      style={[
        styles.statusButton,
        {
          backgroundColor,
          borderColor,
          borderWidth: type === 'incomplete' ? 1 : 0,
        },
      ]}
    >
      {icon}
      <Text color={textColor} style={styles.statusText}>
        {text}
      </Text>
    </View>
  );
};

const ListItem = ({
  title,
  marginTop,
  listIcon,
  showButton,
  type,
  description,
  showArrowIcon,
  showPropertyCard,
  icon,
}) => {
  return (
    <CardBox
      style={{
        marginTop: marginTop || 0,
        width: '100%',
        marginBottom: showPropertyCard ? 80 : 10,
        padding: 14,
        paddingTop: 24,
        position: 'relative',
      }}
      hasShadow
      hasBorderRadius
    >
      {showPropertyCard && <PropertyCard style={{ right: 0, bottom: -80 }} />}

      

      <View style={styles.container}>
        <View style={styles.iconContainer}>
          {icon ? (
            <Image source={{ uri: icon }} style={styles.iconImage} />
          ) : (
            <ListAltIcon data-testid="listAltIcon" style={{ fontSize: 22, color: variables.purple1 }} />
          )}
          <SubHeading style={styles.heading} data-testid="title">
            {title}
          </SubHeading>
        </View>
<>
{showButton && (
        <View style={styles.topRight}>
          <StatusButton type={type} />
        </View>
      )}
     {showArrowIcon && (
          <ArrowForwardIosIcon
            style={{ fontSize: 14, color: variables.purple1, }}
            data-testid="icon"
          />
        )}
</>
   
      </View>

      <SubHeading style={styles.description}>{description}</SubHeading>
    </CardBox>
  );
};

export  {ListItem};